<template>
    <div>
        <div class="flex mb-4">
            <div class="vx-col">
                <vs-switch v-model="enabled" />
            </div>
            <div class="vx-col">
                <span class="ml-2"> Disponível no cardápio (habilitado) </span>
            </div>
        </div>

        <!-- <div class="flex mb-4">
            <div class="vx-col">
                <vs-switch v-model="dispatched" />
            </div>
            <div class="vx-col">
                <span class="ml-2"> Impedir alteração do pedido pelo cliente após confirmado </span>
            </div>
        </div> -->

        <div class="flex">
            <div class="vx-col">
                <vs-switch v-model="express" />
            </div>
            <div class="vx-col">
                <span class="ml-2"> Expresso (Não será necessário confirmar o pedido)  </span>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'

    export default {
        computed : {
            enabled  : {
                get (){
                    return this.productInfo.enabled
                },
                set (enabled) {
                    this.setEnabled(enabled)
                }
            },
            dispatched  : {
                get (){
                    return this.productInfo.dispatched
                },
                set (dispatched) {
                    this.setDispatched(dispatched)
                }
            },
            express  : {
                get (){
                    return this.productInfo.express
                },
                set (express) {
                    this.setExpress(express)
                }
            },
            ...mapState('product', ['productInfo'])
        },

        methods : {
            ...mapMutations('product', ['setEnabled', 'setDispatched', 'setExpress'])
        }
    }
</script>